const chunkMapping = {
	"229": [
		8229
	],
	"250": [
		250
	],
	"355": [
		7355
	],
	"387": [
		387
	],
	"642": [
		3642
	],
	"670": [
		8670
	],
	"700": [
		5700
	],
	"705": [
		2705
	],
	"797": [
		2797
	],
	"884": [
		5884
	],
	"928": [
		8928
	],
	"956": [
		3956
	]
};
const idToExternalAndNameMapping = {
	"250": [
		"default",
		"./Router",
		1918
	],
	"387": [
		"default",
		"./ScenarioPlannerRouter",
		2340
	],
	"2705": [
		"default",
		"./EMRActivationsAdminRouter",
		9169
	],
	"2797": [
		"default",
		"./AutomatedOperationsRouter",
		9169
	],
	"3642": [
		"default",
		"./EMRActivationsRouter",
		9169
	],
	"3956": [
		"default",
		"./AutomatedOperationsAdminRouter",
		9169
	],
	"5700": [
		"default",
		"./Router",
		8283
	],
	"5884": [
		"default",
		"./Router",
		3668
	],
	"7355": [
		"default",
		"./Router",
		5622
	],
	"8229": [
		"default",
		"./Router",
		9197
	],
	"8670": [
		"default",
		"./Router",
		575
	],
	"8928": [
		"default",
		"./AtlasSettingsRouter",
		3668
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}